<template>
  <b-container>
    <!-- HEADER -->
    <b-row>
      <b-col cols="12">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h3 class="font-weight-bold">NGR Reports</h3>
            <small class="text-muted">
              Net Gaming Revenue after deductions and bonuses
            </small>
          </div>

          <div class="d-flex align-items-center">
            <b-form-select
              v-model="range"
              :options="rangeOptions"
              size="sm"
              class="mr-1"
            />
            <b-button variant="primary" class="text-nowrap" size="sm">
              <feather-icon icon="DownloadIcon" />
              Export
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <b-row>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(59, 130, 246);
                background: linear-gradient(
                  rgb(239, 246, 255),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="text-muted"> Total NGR (MTD) </span>
              <h3 class="font-weight-bolder">$892K</h3>
              <div>
                <feather-icon icon="ArrowUpIcon" class="text-success" />
                <span class="small text-success"> 6.2% vs last month</span>
              </div>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(16, 185, 129);
                background: linear-gradient(
                  rgb(236, 253, 245),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted"> Bonus Costs</span>
              <h3 class="font-weight-bolder">$248K</h3>
              <span class="small text-muted"> 20% of GGR </span>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(239, 68, 68);
                background: linear-gradient(
                  rgb(254, 242, 242),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted">POC Tax</span>
              <h3 class="font-weight-bolder">$100K</h3>
              <span class="small text-muted"> 8% of GGR</span>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(132, 204, 22);
                background: linear-gradient(
                  rgb(247, 254, 231),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted">NGR Margin</span>
              <h3 class="font-weight-bolder">6.6%</h3>
              <div>
                <feather-icon icon="ArrowUpIcon" class="text-success" />
                <span class="small text-success"> 0.2pp</span>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col md="8">
        <b-card class="shadow-sm ngr-card">
          <h5 class="mb-1 font-weight-bolder">NGR Breakdown</h5>

          <b-table
            :items="ngrData"
            :fields="fields"
            small
            responsive
            class="mb-0"
          >
            <!-- Amount -->
            <template #cell(amount)="data">
              <span
                :class="{
                  'text-danger': data.item.type === 'minus',
                  'text-success font-weight-bold': data.item.type === 'total',
                }"
              >
                {{ data.item.amount }}
              </span>
            </template>

            <!-- % of GGR -->
            <template #cell(percent)="data">
              <span
                :class="{
                  'font-weight-bold': data.item.type === 'total',
                }"
              >
                {{ data.item.percent }}
              </span>
            </template>

            <!-- Row class -->
            <template #row-class="item">
              {{ item.item.type === "total" ? "ngr-total-row" : "" }}
            </template>
          </b-table>
        </b-card>
      </b-col>

      <b-col md="4">
        <b-card class="shadow-sm">
          <h5 class="font-weight-bolder">NGR Reports</h5>

          <div
            v-for="(file, index) in reports"
            :key="index"
            class="report-item"
          >
            <div class="d-flex align-items-center">
              <div class="excel-icon-purple mr-2">
                <feather-icon icon="FileTextIcon" size="16" />
              </div>

              <div class="flex-grow-1">
                <div class="font-weight-semibold">
                  {{ file.name }}
                </div>
                <small class="text-muted">
                  {{ file.status }}
                </small>
              </div>

              <b-button size="sm" variant="primary">
                <feather-icon icon="DownloadIcon" size="14" />
              </b-button>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BFormSelect,
  BButton,
  BLink,
  BTable,
} from "bootstrap-vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BFormSelect,
    BButton,
    BLink,
    BTable,
    FeatherIcon,
  },
  data() {
    const rangeOptions = [
      { value: "7days", text: "Last 7 days" },
      { value: "30days", text: "Last 30 days" },
      { value: "this_month", text: "This Month" },
      { value: "last_quarter", text: "Last Quarter" },
    ];
    return {
      range: rangeOptions[0].value,
      rangeOptions,
      fields: [
        { key: "component", label: "Component" },
        { key: "amount", label: "Amount" },
        { key: "percent", label: "% of GGR" },
      ],

      ngrData: [
        {
          component: "Gross Gaming Revenue (GGR)",
          amount: "$1,240,000",
          percent: "100%",
          type: "normal",
        },
        {
          component: "Less: Bonus Bets Used",
          amount: "-$148,800",
          percent: "12%",
          type: "minus",
        },
        {
          component: "Less: Free Bets",
          amount: "-$62,000",
          percent: "5%",
          type: "minus",
        },
        {
          component: "Less: Cashback Paid",
          amount: "-$37,200",
          percent: "3%",
          type: "minus",
        },
        {
          component: "Less: POC Tax",
          amount: "-$99,200",
          percent: "8%",
          type: "minus",
        },
        {
          component: "Net Gaming Revenue (NGR)",
          amount: "$892,800",
          percent: "72%",
          type: "total",
        },
      ],

      reports: [
        {
          name: "ngr_january_2026.xlsx",
          status: "Updated: Today",
        },
        {
          name: "ngr_december_2025.xlsx",
          status: "Final",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.ngr-card {
  background: #ffffff;
}

.report-item {
  padding: 12px 0;
  border-bottom: 1px solid #f1f1f1;
}

.report-item:last-child {
  border-bottom: none;
}

.excel-icon-purple {
  width: 36px;
  height: 36px;
  background: #ede9fe;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ngr-total-row {
  background-color: #d1fae5 !important;
  font-weight: 600;
}
</style>